import { http, HttpHandler, HttpResponse } from 'msw';
import enEngage from '/locales/engage/en.i18n.json?url';
import enUserTest from '/locales/user-test/en.i18n.json?url';

export const mocks = {
  engageDefault: http.get('*/locales/engage/en.i18n.json', () =>
    HttpResponse.json(enEngage, { status: 200 }),
  ),
  userTestDefault: http.get('*/locales/user-test/en.i18n.json', () =>
    HttpResponse.json(enUserTest, { status: 200 }),
  ),
  translationLoadFail: http.get(
    '*/locales/*/en.i18n.json',
    () => new HttpResponse(null, { status: 401 }),
  ),
} satisfies Record<PropertyKey, HttpHandler>;
